import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import TextField from "../../../Utils/TextField"
import { useFormik } from "formik"
import styles from "../../../../../styles/Participant-Employment.module.css"
import { useEffect } from "react"
import { InputNumber } from "primereact/inputnumber"

const Conviction = ({ visible, setVisible, edit, setValue, jobs, setEdit }) => {
  const { v4: uuidv4 } = require("uuid")
  const formik = useFormik({
    initialValues: {
      type: "",
      year: 1990,
      sentence: "",
    },
    validate: (data) => {
      let errors = {}

      return errors
    },
    onSubmit: (data) => {
      data && saveConviction(data)
      formik.resetForm()
      setVisible(false)
    },
  })
  useEffect(() => {
    if (edit) {
      formik.setValues({
        type: edit?.type,
        year: edit?.year,
        sentence: edit?.sentence,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit])

  const footer = () => {
    return (
      <div className={styles.education_form_footer}>
        <Button
          label="Cancel"
          type="button"
          onClick={() => {
            formik.resetForm()
            formik.setErrors({})
            setEdit(null)
            setVisible(false)
          }}
          className={`${styles.button} ${styles.button_secondary}`}
        />
        <Button
          label={`${edit ? "Edit" : "Create"} conviction`}
          type="submit"
          style={{ marginLeft: "1rem" }}
          className={`${styles.button}`}
        />
      </div>
    )
  }
  const saveConviction = (conviction) => {
    const cont = { ...conviction, id: uuidv4(), new: true }
    if (edit) {
      const newSave = jobs?.map((s) => {
        let newValue = { ...s }
        if (s.id === edit?.id) {
          newValue.type = cont.type
          newValue.year = cont.year
          newValue.sentence = cont.sentence
        }
        return newValue
      })
      setValue("legal_convictions", newSave)
      setEdit(null)
    } else {
      setValue("legal_convictions", [cont, ...jobs])
    }
  }
  const header = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "solid 3px #e7e0f1",
          marginBottom: "20px",
        }}
      >
        <p
          style={{
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "33px",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >{`${edit ? "Edit" : "Add"} conviction`}</p>
        <Button
          className={styles.rounded_btn}
          icon="pi pi-times"
          type="button"
          onClick={() => {
            formik.resetForm()
            setVisible(false)
            setEdit(null)
          }}
          style={{ marginTop: "10px" }}
        />
      </div>
    )
  }
  return (
    <Dialog
      visible={visible}
      style={{ width: "50vw" }}
      onHide={() => {
        formik.resetForm()
        formik.setErrors({})
        setEdit(null)
        setVisible(false)
      }}
      showHeader={false}
    >
      {header()}
      <form onSubmit={formik.handleSubmit}>
        <div style={{ marginBottom: "15px" }}>
          <TextField
            label={"Type of conviction"}
            value={formik.values.type}
            setValue={formik.setFieldValue}
            valueName={"type"}
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <div className={styles.field} style={{ width: "100%" }}>
            <label className={styles.label}>{"Year"}</label>
            <InputNumber
              className={styles.fix_input_number}
              value={formik.values.year}
              min={1990}
              onChange={(e) => {
                formik.setFieldValue("year", e.value)
              }}
              style={{ width: "30%" }}
              showButtons
              max={new Date().getFullYear()}
              useGrouping={false}
            />
          </div>
        </div>
        <div style={{ marginBottom: "15px" }}>
          <TextField
            label={"Sentence/Disposition"}
            value={formik.values.sentence}
            setValue={formik.setFieldValue}
            valueName={"sentence"}
          />
        </div>
        {footer()}
      </form>
    </Dialog>
  )
}
export default Conviction
